import { AUTH_USER_FRAGMENT } from 'features/user/api/authUser'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { gql } from 'providers/tanstack-query/utils'

import type { RefreshTokenData, RefreshTokenVars } from './types'
import type { Ability } from 'providers/casl'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const REFRESH_TOKEN = (
  ability: Ability,
): TypedDocumentNode<RefreshTokenData, RefreshTokenVars> => gql`
  ${AUTH_USER_FRAGMENT(ability)}
  ${ERROR_FRAGMENT}

  mutation refreshToken($refreshToken: String!) {
    refreshToken(input: { refreshToken: $refreshToken }) {
      accessToken
      refreshToken

      user {
        ...AuthUserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
